import JsxHelper from '../../../Helpers/JsxHelper';
import TpJobItem from './TpJobItem';

export default class UninvoiceableTpJobItem extends TpJobItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: TpJobItem.getSelectedCellHeader,
        orderById: '',
        data: TpJobItem.getSelectedCellContent,
        minWidth: 20,
        rolekey: 'project_edit',
      },
      { label: 'Third Party Job ID', orderById: 'ThirdPartyJobId', data: TpJobItem.idFunction },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        minWidth: 50,
      },
      {
        label: 'Location',
        orderById: 'ThirdPartyLocationName',
        data: 'ThirdPartyLocationName',
        minWidth: 50,
      },
      {
        label: 'Campaign',
        orderById: 'CampaignName',
        data: 'CampaignName',
        minWidth: 50,
      },
      {
        label: 'Client Fee Total',
        orderById: 'ClientFeeBaseWithSymbol',
        data: 'ClientFeeBaseWithSymbol',
        minWidth: 80,
      },
      {
        label: 'Reimb. Total',
        orderById: 'ReimbTotalExchangedWithSymbol',
        data: 'ReimbTotalExchangedWithSymbol',
        minWidth: 80,
      },
      {
        label: 'Fieldwork Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        minWidth: 50,
      },
      { label: 'FW Fee', orderById: 'FieldworkFeeWithSymbol', data: 'FieldworkFeeWithSymbol', minWidth: 80 }, // TODO: This should be using the TpJob Currency (as_rcysymbol)
      {
        label: 'Evaluator',
        orderById: 'TpEvaluatorFullName',
        data: 'TpEvaluatorFullName',
        minWidth: 50,
      },
      {
        label: 'Status',
        orderById: 'ThirdPartyJobStatus',
        data: TpJobItem.getStatusCellContent,
        minWidth: 30,
      },
      {
        label: 'Completed On',
        orderById: 'JobDate',
        data: 'JobDate',
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'ThirdPartyLocationCountry',
        data: 'ThirdPartyLocationCountry',
        minWidth: 50,
      },
      {
        label: 'Uninvoiceable',
        orderById: 'IsUninvoiceable',
        data: 'IsUninvoiceable',
        minWidth: 20,
      },
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
    ];
  }
}
